/** @format */

import styled from 'styled-components';

export const UserGroupContainer = styled.div`
	margin-top: 13px;
	display: flex;
`;

export const AvatarContainer = styled.div`
	margin-top: 4px;
	overflow: hidden;
	vertical-align: middle;
	width: 30px;
	height: 30px;
	border-radius: 50%;
	background: white;
	cursor: pointer;
	${(props) => props.status && 'padding: 2px 10px;'}
`;

export const StatusButtonContainer = styled.div`
	display: flex;
	padding: 0 4px;
	border-radius: 50px;
	background: #ffd934;
	height: 38px;
	min-width: 38px;
	font-size: 16px;
	margin-right: 16px;

	&:hover {
		background: #ffe75c;
	}

	&:active {
		background: #ffd934;
	}
`;

export const StatusWrapper = styled.div`
	margin-left: 17px;
	margin-right: 16px;
	margin-top: 8px;
	height: 23px;
	font-size: 16px;
	line-height: 23px;
	color: #3b3b3a;
	vertical-align: middle;
`;

export const SpinImg = styled.img`
	animation: spin 0.7s linear 0s infinite;
`;

export const ProfileModalWrapper = styled.div`
	top: 60px;
	right: 10px;
	position: fixed;
`